import CrudCustom from '../../../libs/custom/CrudCustom';


let PenyusutanPeriodeAkunService = new CrudCustom('/penyusutan-periode-akuns');
export default PenyusutanPeriodeAkunService;
